/** Section URL slug for a jewel.material value */
export function sectionPathForMaterial(material) {
  if (material === 'gold_plated') return '/section/gold-plated';
  if (material === 'gold') return '/section/gold';
  if (material === 'silver') return '/section/silver';
  if (material === 'fancy') return '/section/fancy';
  return '/';
}
